import React from 'react';
import cn from 'classnames';
import * as styles from './Wrapper.module.scss';

export default function Wrapper({
  className,
  name,
  showName = false,
  mods,
  onClick,
  role,
  children,
}) {
  const preparedMods = mods?.map(mod => styles[mod]);

  if (showName && name) {
    return (
      <figure
        className={cn(styles.item, mods && preparedMods, className)}
        onClick={onClick}
        role={role}
      >
        {children}
        <figcaption className={styles.iconName}>{name}</figcaption>
      </figure>
    );
  }

  return (
    <div className={cn(styles.item, mods && preparedMods, className)} onClick={onClick} role={role}>
      {children}
    </div>
  );
}
